/**
 * Generated from NellieBlyStoryLayout.fla
 */
export function NellieBlyStoryLayout(this: INellieBlyStoryLayout) {
	const scene1Start = this.scene1Start;
	NellieBlyStoryLayout_scene1Start.call(this.scene1Start);
	scene1Start.x = 0;
	scene1Start.y = 0;
	if (scene1Start.onLayout) scene1Start.onLayout();
	const scene2Encounter = this.scene2Encounter;
	NellieBlyStoryLayout_scene2Encounter.call(this.scene2Encounter);
	scene2Encounter.x = 0;
	scene2Encounter.y = 0;
	if (scene2Encounter.onLayout) scene2Encounter.onLayout();
	const scene3Reaction = this.scene3Reaction;
	NellieBlyStoryLayout_scene3Reaction.call(this.scene3Reaction);
	scene3Reaction.x = 0;
	scene3Reaction.y = 0;
	if (scene3Reaction.onLayout) scene3Reaction.onLayout();
	const scene4Land = this.scene4Land;
	NellieBlyStoryLayout_scene4Land.call(this.scene4Land);
	scene4Land.x = 0;
	scene4Land.y = 0;
	if (scene4Land.onLayout) scene4Land.onLayout();
	const scene5Speech = this.scene5Speech;
	NellieBlyStoryLayout_scene5Speech.call(this.scene5Speech);
	scene5Speech.x = 0;
	scene5Speech.y = 0;
	if (scene5Speech.onLayout) scene5Speech.onLayout();
	const scene6End = this.scene6End;
	NellieBlyStoryLayout_scene6End.call(this.scene6End);
	scene6End.x = 0;
	scene6End.y = 0;
	if (scene6End.onLayout) scene6End.onLayout();
	return this;
}
export function NellieBlyStoryLayout_scene1Start(this: INellieBlyStoryLayout_scene1Start) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":true,"option":"swing"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYSwing1.call(items[0] as INellieBlyStoryLayout_blyYSwing1);
		(items[0] as INellieBlyStoryLayout_blyYSwing1).animation = "squishStretch";
		(items[0] as INellieBlyStoryLayout_blyYSwing1).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyYSwing1).option = "swing";
		items[0].x = 1023.9;
		items[0].y = 1165.9;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch","isButton":true,"option":"seesaw"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blySeesaw2.call(items[1] as INellieBlyStoryLayout_blySeesaw2);
		(items[1] as INellieBlyStoryLayout_blySeesaw2).animation = "squishStretch";
		(items[1] as INellieBlyStoryLayout_blySeesaw2).isButton = true;
		(items[1] as INellieBlyStoryLayout_blySeesaw2).option = "seesaw";
		items[1].x = 1077.2;
		items[1].y = 1144;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch","isButton":true,"option":"duck"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyYDuck1.call(items[2] as INellieBlyStoryLayout_blyYDuck1);
		(items[2] as INellieBlyStoryLayout_blyYDuck1).animation = "squishStretch";
		(items[2] as INellieBlyStoryLayout_blyYDuck1).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyYDuck1).option = "duck";
		items[2].x = 1004.45;
		items[2].y = 1122.3;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"squishStretch","isButton":true,"option":"slide"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blySlide1.call(items[3] as INellieBlyStoryLayout_blySlide1);
		(items[3] as INellieBlyStoryLayout_blySlide1).animation = "squishStretch";
		(items[3] as INellieBlyStoryLayout_blySlide1).isButton = true;
		(items[3] as INellieBlyStoryLayout_blySlide1).option = "slide";
		items[3].x = 1028.55;
		items[3].y = 1182.6;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYSwing1(this: INellieBlyStoryLayout_blyYSwing1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYSwing.call(items[0] as INellieBlyStoryLayout_blyYSwing);
		(items[0] as INellieBlyStoryLayout_blyYSwing).animation = "";
		(items[0] as INellieBlyStoryLayout_blyYSwing).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyYSwing).option = "";
		items[0].x = -604;
		items[0].y = -442;
		items[0].width = 1732.00;
		items[0].height = 988.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYSwing(this: INellieBlyStoryLayout_blyYSwing) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-swing.png", 0.151, 0.553);
	return this;
}
function NellieBlyStoryLayout_blySeesaw2(this: INellieBlyStoryLayout_blySeesaw2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySeesaw1.call(items[0] as INellieBlyStoryLayout_blySeesaw1);
		items[0].x = 0;
		items[0].y = -179;
		items[0].width = 1229.00;
		items[0].height = 358.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":""});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyYSeesaw1.call(items[1] as INellieBlyStoryLayout_blyYSeesaw1);
		(items[1] as INellieBlyStoryLayout_blyYSeesaw1).animation = "";
		(items[1] as INellieBlyStoryLayout_blyYSeesaw1).isButton = false;
		(items[1] as INellieBlyStoryLayout_blyYSeesaw1).option = "";
		items[1].x = -194.9;
		items[1].y = -203.1;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySeesaw1(this: INellieBlyStoryLayout_blySeesaw1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-seesaw.png", 0.500, 0.500);
	return this;
}
function NellieBlyStoryLayout_blyYSeesaw1(this: INellieBlyStoryLayout_blyYSeesaw1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYSeesaw.call(items[0] as INellieBlyStoryLayout_blyYSeesaw);
		(items[0] as INellieBlyStoryLayout_blyYSeesaw).animation = "";
		(items[0] as INellieBlyStoryLayout_blyYSeesaw).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyYSeesaw).option = "";
		items[0].x = -367.15;
		items[0].y = 110.4;
		items[0].width = 451.00;
		items[0].height = 530.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYSeesaw(this: INellieBlyStoryLayout_blyYSeesaw) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-seesaw.png", 0.500, 1.000);
	return this;
}
function NellieBlyStoryLayout_blyYDuck1(this: INellieBlyStoryLayout_blyYDuck1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYDuck.call(items[0] as INellieBlyStoryLayout_blyYDuck);
		(items[0] as INellieBlyStoryLayout_blyYDuck).animation = "";
		(items[0] as INellieBlyStoryLayout_blyYDuck).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyYDuck).option = "";
		items[0].x = -76;
		items[0].y = -331;
		items[0].width = 729.00;
		items[0].height = 933.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYDuck(this: INellieBlyStoryLayout_blyYDuck) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-duck.png", 0.396, 0.645);
	return this;
}
function NellieBlyStoryLayout_blySlide1(this: INellieBlyStoryLayout_blySlide1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySlideBack.call(items[0] as INellieBlyStoryLayout_blySlideBack);
		items[0].x = -256.4;
		items[0].y = -729.8;
		items[0].width = 770.00;
		items[0].height = 697.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":""});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyYSlide1.call(items[1] as INellieBlyStoryLayout_blyYSlide1);
		(items[1] as INellieBlyStoryLayout_blyYSlide1).animation = "";
		(items[1] as INellieBlyStoryLayout_blyYSlide1).isButton = false;
		(items[1] as INellieBlyStoryLayout_blyYSlide1).option = "";
		items[1].x = -62.6;
		items[1].y = -195;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		NellieBlyStoryLayout_blySlideFront.call(items[2] as INellieBlyStoryLayout_blySlideFront);
		items[2].x = -418.15;
		items[2].y = -752.6;
		items[2].width = 613.00;
		items[2].height = 752.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySlideBack(this: INellieBlyStoryLayout_blySlideBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-slide-back.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyYSlide1(this: INellieBlyStoryLayout_blyYSlide1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYSlide.call(items[0] as INellieBlyStoryLayout_blyYSlide);
		(items[0] as INellieBlyStoryLayout_blyYSlide).animation = "";
		(items[0] as INellieBlyStoryLayout_blyYSlide).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyYSlide).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 466.00;
		items[0].height = 564.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYSlide(this: INellieBlyStoryLayout_blyYSlide) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-slide.png", 0.500, 1.000);
	return this;
}
function NellieBlyStoryLayout_blySlideFront(this: INellieBlyStoryLayout_blySlideFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-slide-front.png", 0.000, 0.000);
	return this;
}
export function NellieBlyStoryLayout_scene2Encounter(this: INellieBlyStoryLayout_scene2Encounter) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"children:squishStretch appear delay=0.2","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_slotStart.call(items[0] as INellieBlyStoryLayout_slotStart);
		(items[0] as INellieBlyStoryLayout_slotStart).animation = "children:squishStretch appear delay=0.2";
		(items[0] as INellieBlyStoryLayout_slotStart).isButton = false;
		(items[0] as INellieBlyStoryLayout_slotStart).option = "";
		items[0].x = -163.65;
		items[0].y = 188.15;
		if (items[0].scale) items[0].scale.x = 0.732;
		if (items[0].scale) items[0].scale.y = 0.732;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		NellieBlyStoryLayout_paperLayer.call(items[1] as INellieBlyStoryLayout_paperLayer);
		(items[1] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"id=birdStart","isButton":true,"option":"undefined"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyBird.call(items[2] as INellieBlyStoryLayout_blyBird);
		(items[2] as INellieBlyStoryLayout_blyBird).animation = "id=birdStart";
		(items[2] as INellieBlyStoryLayout_blyBird).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyBird).option = "undefined";
		items[2].x = 1235.85;
		items[2].y = 643.05;
		items[2].rotation = 0.3491;
		if (items[2].scale) items[2].scale.x = 0.500;
		if (items[2].scale) items[2].scale.y = 0.500;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"id=balloonStart","isButton":true,"option":"undefined"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blyBalloon1.call(items[3] as INellieBlyStoryLayout_blyBalloon1);
		(items[3] as INellieBlyStoryLayout_blyBalloon1).animation = "id=balloonStart";
		(items[3] as INellieBlyStoryLayout_blyBalloon1).isButton = true;
		(items[3] as INellieBlyStoryLayout_blyBalloon1).option = "undefined";
		items[3].x = 1259.15;
		items[3].y = 684;
		items[3].rotation = 0.3491;
		if (items[3].scale) items[3].scale.x = 0.500;
		if (items[3].scale) items[3].scale.y = 0.500;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"id=windStart","isButton":true,"option":"undefined"});
	}
	if (items[4]) {
		NellieBlyStoryLayout_blyWind.call(items[4] as INellieBlyStoryLayout_blyWind);
		(items[4] as INellieBlyStoryLayout_blyWind).animation = "id=windStart";
		(items[4] as INellieBlyStoryLayout_blyWind).isButton = true;
		(items[4] as INellieBlyStoryLayout_blyWind).option = "undefined";
		items[4].x = 1080;
		items[4].y = 830;
		items[4].rotation = 0.1745;
		if (items[4].scale) items[4].scale.x = 0.500;
		if (items[4].scale) items[4].scale.y = 0.500;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"id=kiteStart","isButton":true,"option":"undefined"});
	}
	if (items[5]) {
		NellieBlyStoryLayout_blyKite1.call(items[5] as INellieBlyStoryLayout_blyKite1);
		(items[5] as INellieBlyStoryLayout_blyKite1).animation = "id=kiteStart";
		(items[5] as INellieBlyStoryLayout_blyKite1).isButton = true;
		(items[5] as INellieBlyStoryLayout_blyKite1).option = "undefined";
		items[5].x = 1261.55;
		items[5].y = 758.05;
		items[5].rotation = 0.3491;
		if (items[5].scale) items[5].scale.x = 0.500;
		if (items[5].scale) items[5].scale.y = 0.500;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"from birdStart appear time=0.6","isButton":true,"option":"bird"});
	}
	if (items[6]) {
		NellieBlyStoryLayout_blyBird.call(items[6] as INellieBlyStoryLayout_blyBird);
		(items[6] as INellieBlyStoryLayout_blyBird).animation = "from birdStart appear time=0.6";
		(items[6] as INellieBlyStoryLayout_blyBird).isButton = true;
		(items[6] as INellieBlyStoryLayout_blyBird).option = "bird";
		items[6].x = 1502.85;
		items[6].y = 289.75;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"from balloonStart appear time=0.6","isButton":true,"option":"balloon"});
	}
	if (items[7]) {
		NellieBlyStoryLayout_blyBalloon1.call(items[7] as INellieBlyStoryLayout_blyBalloon1);
		(items[7] as INellieBlyStoryLayout_blyBalloon1).animation = "from balloonStart appear time=0.6";
		(items[7] as INellieBlyStoryLayout_blyBalloon1).isButton = true;
		(items[7] as INellieBlyStoryLayout_blyBalloon1).option = "balloon";
		items[7].x = 1602.85;
		items[7].y = 418.75;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"from windStart appear time=0.6","isButton":true,"option":"gust"});
	}
	if (items[8]) {
		NellieBlyStoryLayout_blyWind.call(items[8] as INellieBlyStoryLayout_blyWind);
		(items[8] as INellieBlyStoryLayout_blyWind).animation = "from windStart appear time=0.6";
		(items[8] as INellieBlyStoryLayout_blyWind).isButton = true;
		(items[8] as INellieBlyStoryLayout_blyWind).option = "gust";
		items[8].x = 1341.8;
		items[8].y = 647.05;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"from kiteStart appear time=0.6","isButton":true,"option":"kite"});
	}
	if (items[9]) {
		NellieBlyStoryLayout_blyKite1.call(items[9] as INellieBlyStoryLayout_blyKite1);
		(items[9] as INellieBlyStoryLayout_blyKite1).animation = "from kiteStart appear time=0.6";
		(items[9] as INellieBlyStoryLayout_blyKite1).isButton = true;
		(items[9] as INellieBlyStoryLayout_blyKite1).option = "kite";
		items[9].x = 1547.75;
		items[9].y = 486.65;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"isPaperLayer":true});
	}
	if (items[10]) {
		NellieBlyStoryLayout_paperLayer.call(items[10] as INellieBlyStoryLayout_paperLayer);
		(items[10] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[10].x = 0;
		items[10].y = 0;
		items[10].width = 2048.00;
		items[10].height = 1536.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"squishStretch","isButton":true,"option":""});
	}
	if (items[11]) {
		NellieBlyStoryLayout_blyYReachout1.call(items[11] as INellieBlyStoryLayout_blyYReachout1);
		(items[11] as INellieBlyStoryLayout_blyYReachout1).animation = "squishStretch";
		(items[11] as INellieBlyStoryLayout_blyYReachout1).isButton = true;
		(items[11] as INellieBlyStoryLayout_blyYReachout1).option = "";
		items[11].x = 870.1;
		items[11].y = 1160.45;
		if (items[11].onLayout) items[11].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotStart(this: INellieBlyStoryLayout_slotStart) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"swing"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySwing.call(items[0] as INellieBlyStoryLayout_blySwing);
		(items[0] as INellieBlyStoryLayout_blySwing).animation = "";
		(items[0] as INellieBlyStoryLayout_blySwing).isButton = true;
		(items[0] as INellieBlyStoryLayout_blySwing).option = "swing";
		items[0].x = 1026.35;
		items[0].y = 1137.4;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"seesaw"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blySeesaw.call(items[1] as INellieBlyStoryLayout_blySeesaw);
		(items[1] as INellieBlyStoryLayout_blySeesaw).animation = "";
		(items[1] as INellieBlyStoryLayout_blySeesaw).isButton = true;
		(items[1] as INellieBlyStoryLayout_blySeesaw).option = "seesaw";
		items[1].x = 1146.95;
		items[1].y = 1134.6;
		if (items[1].scale) items[1].scale.x = 0.925;
		if (items[1].scale) items[1].scale.y = 0.925;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"duck"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyDuck.call(items[2] as INellieBlyStoryLayout_blyDuck);
		(items[2] as INellieBlyStoryLayout_blyDuck).animation = "";
		(items[2] as INellieBlyStoryLayout_blyDuck).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyDuck).option = "duck";
		items[2].x = 706.6;
		items[2].y = 1186;
		if (items[2].scale) items[2].scale.x = 0.925;
		if (items[2].scale) items[2].scale.y = 0.925;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"slide"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blySlide.call(items[3] as INellieBlyStoryLayout_blySlide);
		(items[3] as INellieBlyStoryLayout_blySlide).animation = "";
		(items[3] as INellieBlyStoryLayout_blySlide).isButton = true;
		(items[3] as INellieBlyStoryLayout_blySlide).option = "slide";
		items[3].x = 1121.25;
		items[3].y = 1169.1;
		if (items[3].scale) items[3].scale.x = 0.925;
		if (items[3].scale) items[3].scale.y = 0.925;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySwing(this: INellieBlyStoryLayout_blySwing) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySwing1.call(items[0] as INellieBlyStoryLayout_blySwing1);
		items[0].x = 0;
		items[0].y = -402.5;
		items[0].width = 1411.00;
		items[0].height = 805.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySwing1(this: INellieBlyStoryLayout_blySwing1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-swing.png", 0.500, 0.500);
	return this;
}
function NellieBlyStoryLayout_blySeesaw(this: INellieBlyStoryLayout_blySeesaw) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySeesaw1.call(items[0] as INellieBlyStoryLayout_blySeesaw1);
		items[0].x = 0;
		items[0].y = -179;
		items[0].width = 1229.00;
		items[0].height = 358.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyDuck(this: INellieBlyStoryLayout_blyDuck) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyDuck1.call(items[0] as INellieBlyStoryLayout_blyDuck1);
		items[0].x = 0;
		items[0].y = -304.5;
		items[0].width = 546.00;
		items[0].height = 609.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyDuck1(this: INellieBlyStoryLayout_blyDuck1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-duck.png", 0.500, 0.500);
	return this;
}
function NellieBlyStoryLayout_blySlide(this: INellieBlyStoryLayout_blySlide) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySlideBack.call(items[0] as INellieBlyStoryLayout_blySlideBack);
		items[0].x = -304.1;
		items[0].y = -729.2;
		items[0].width = 770.00;
		items[0].height = 697.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blySlideFront.call(items[1] as INellieBlyStoryLayout_blySlideFront);
		items[1].x = -465.85;
		items[1].y = -752;
		items[1].width = 613.00;
		items[1].height = 752.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_paperLayer(this: INellieBlyStoryLayout_paperLayer) {
	return this;
}
function NellieBlyStoryLayout_blyBird(this: INellieBlyStoryLayout_blyBird) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBirdBack.call(items[0] as INellieBlyStoryLayout_blyBirdBack);
		items[0].x = -330.5;
		items[0].y = -232;
		items[0].width = 661.00;
		items[0].height = 464.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyDrZoom.call(items[1] as INellieBlyStoryLayout_blyDrZoom);
		items[1].x = -19.85;
		items[1].y = -80.85;
		items[1].width = 224.91;
		items[1].height = 232.22;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyBirdFront.call(items[2] as INellieBlyStoryLayout_blyBirdFront);
		items[2].x = -194.25;
		items[2].y = -57.95;
		items[2].width = 322.00;
		items[2].height = 225.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBirdBack(this: INellieBlyStoryLayout_blyBirdBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-bird-back.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyDrZoom(this: INellieBlyStoryLayout_blyDrZoom) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-dr-zoom.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyBirdFront(this: INellieBlyStoryLayout_blyBirdFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-bird-front.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyBalloon1(this: INellieBlyStoryLayout_blyBalloon1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyDrZoom.call(items[0] as INellieBlyStoryLayout_blyDrZoom);
		items[0].x = -138.5;
		items[0].y = 15.6;
		items[0].width = 277.00;
		items[0].height = 286.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyBalloon.call(items[1] as INellieBlyStoryLayout_blyBalloon);
		items[1].x = -89.9;
		items[1].y = -301.55;
		items[1].width = 223.00;
		items[1].height = 544.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBalloon(this: INellieBlyStoryLayout_blyBalloon) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-balloon.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyWind(this: INellieBlyStoryLayout_blyWind) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyDrZoom.call(items[0] as INellieBlyStoryLayout_blyDrZoom);
		items[0].x = 121.6;
		items[0].y = -213.4;
		items[0].width = 277.00;
		items[0].height = 286.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyGust.call(items[1] as INellieBlyStoryLayout_blyGust);
		items[1].x = -574;
		items[1].y = -208.6;
		items[1].width = 1148.00;
		items[1].height = 422.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyGust(this: INellieBlyStoryLayout_blyGust) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-gust.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyKite1(this: INellieBlyStoryLayout_blyKite1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyDrZoom.call(items[0] as INellieBlyStoryLayout_blyDrZoom);
		items[0].x = -129.55;
		items[0].y = 13.4;
		items[0].rotation = 0.6047;
		items[0].width = 277.00;
		items[0].height = 286.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyKite.call(items[1] as INellieBlyStoryLayout_blyKite);
		items[1].x = -192.85;
		items[1].y = -406.1;
		items[1].width = 485.00;
		items[1].height = 665.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyKite(this: INellieBlyStoryLayout_blyKite) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-kite.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyYReachout1(this: INellieBlyStoryLayout_blyYReachout1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYReachout.call(items[0] as INellieBlyStoryLayout_blyYReachout);
		(items[0] as INellieBlyStoryLayout_blyYReachout).animation = "";
		(items[0] as INellieBlyStoryLayout_blyYReachout).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyYReachout).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 527.00;
		items[0].height = 540.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYReachout(this: INellieBlyStoryLayout_blyYReachout) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-reachout.png", 0.500, 1.000);
	return this;
}
export function NellieBlyStoryLayout_scene3Reaction(this: INellieBlyStoryLayout_scene3Reaction) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_slotStart.call(items[0] as INellieBlyStoryLayout_slotStart);
		items[0].x = -163.65;
		items[0].y = 188.15;
		if (items[0].scale) items[0].scale.x = 0.732;
		if (items[0].scale) items[0].scale.y = 0.732;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch","isButton":true,"option":"boat"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyBoat.call(items[1] as INellieBlyStoryLayout_blyBoat);
		(items[1] as INellieBlyStoryLayout_blyBoat).animation = "squishStretch";
		(items[1] as INellieBlyStoryLayout_blyBoat).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyBoat).option = "boat";
		items[1].x = 1538.5;
		items[1].y = 1164.4;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch","isButton":true,"option":"jetpack"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyJetpack.call(items[2] as INellieBlyStoryLayout_blyJetpack);
		(items[2] as INellieBlyStoryLayout_blyJetpack).animation = "squishStretch";
		(items[2] as INellieBlyStoryLayout_blyJetpack).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyJetpack).option = "jetpack";
		items[2].x = 1540.1;
		items[2].y = 549;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"slideIn left time=1","isButton":true,"option":"bike"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blyBike.call(items[3] as INellieBlyStoryLayout_blyBike);
		(items[3] as INellieBlyStoryLayout_blyBike).animation = "slideIn left time=1";
		(items[3] as INellieBlyStoryLayout_blyBike).isButton = true;
		(items[3] as INellieBlyStoryLayout_blyBike).option = "bike";
		items[3].x = 1453.95;
		items[3].y = 1123.6;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"slideIn left time=1","isButton":true,"option":"skates"});
	}
	if (items[4]) {
		NellieBlyStoryLayout_blyRollerskate1.call(items[4] as INellieBlyStoryLayout_blyRollerskate1);
		(items[4] as INellieBlyStoryLayout_blyRollerskate1).animation = "slideIn left time=1";
		(items[4] as INellieBlyStoryLayout_blyRollerskate1).isButton = true;
		(items[4] as INellieBlyStoryLayout_blyRollerskate1).option = "skates";
		items[4].x = 1359.65;
		items[4].y = 1154.4;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBoat(this: INellieBlyStoryLayout_blyBoat) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBoatBack.call(items[0] as INellieBlyStoryLayout_blyBoatBack);
		items[0].x = -387.5;
		items[0].y = -891;
		items[0].width = 775.00;
		items[0].height = 891.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBoatBack(this: INellieBlyStoryLayout_blyBoatBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-boat.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyJetpack(this: INellieBlyStoryLayout_blyJetpack) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyJetpack1.call(items[0] as INellieBlyStoryLayout_blyJetpack1);
		(items[0] as INellieBlyStoryLayout_blyJetpack1).animation = "";
		(items[0] as INellieBlyStoryLayout_blyJetpack1).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyJetpack1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 636.00;
		items[0].height = 684.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyJetpack1(this: INellieBlyStoryLayout_blyJetpack1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-jetpack.png", 0.500, 0.389);
	return this;
}
function NellieBlyStoryLayout_blyBike(this: INellieBlyStoryLayout_blyBike) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBicycle1.call(items[0] as INellieBlyStoryLayout_blyBicycle1);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 449.00;
		items[0].height = 667.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBicycle1(this: INellieBlyStoryLayout_blyBicycle1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-bike.png", 0.501, 1.000);
	return this;
}
function NellieBlyStoryLayout_blyRollerskate1(this: INellieBlyStoryLayout_blyRollerskate1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyRollerskate.call(items[0] as INellieBlyStoryLayout_blyRollerskate);
		(items[0] as INellieBlyStoryLayout_blyRollerskate).animation = "";
		(items[0] as INellieBlyStoryLayout_blyRollerskate).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyRollerskate).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 638.00;
		items[0].height = 685.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyRollerskate(this: INellieBlyStoryLayout_blyRollerskate) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-rollerskate.png", 0.500, 1.000);
	return this;
}
export function NellieBlyStoryLayout_scene4Land(this: INellieBlyStoryLayout_scene4Land) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlaygroundBg.call(items[0] as INellieBlyStoryLayout_blyPlaygroundBg);
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).option = "playground";
		items[0].x = 84.3;
		items[0].y = 29.85;
		items[0].width = 1708.00;
		items[0].height = 998.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		NellieBlyStoryLayout_paperLayer.call(items[1] as INellieBlyStoryLayout_paperLayer);
		(items[1] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		NellieBlyStoryLayout_slotLand.call(items[2] as INellieBlyStoryLayout_slotLand);
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		NellieBlyStoryLayout_paperLayer.call(items[3] as INellieBlyStoryLayout_paperLayer);
		(items[3] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"squishStretch","isButton":true,"option":"spaghetti"});
	}
	if (items[4]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[4] as INellieBlyStoryLayout_blyDrZoom1);
		(items[4] as INellieBlyStoryLayout_blyDrZoom1).animation = "squishStretch";
		(items[4] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[4] as INellieBlyStoryLayout_blyDrZoom1).option = "spaghetti";
		items[4].x = 1438.55;
		items[4].y = 282.15;
		if (items[4].scale) items[4].scale.x = 0.560;
		if (items[4].scale) items[4].scale.y = 0.560;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch","isButton":true,"option":"pyramid"});
	}
	if (items[5]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[5] as INellieBlyStoryLayout_blyDrZoom1);
		(items[5] as INellieBlyStoryLayout_blyDrZoom1).animation = "squishStretch";
		(items[5] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[5] as INellieBlyStoryLayout_blyDrZoom1).option = "pyramid";
		items[5].x = 1234.15;
		items[5].y = 524.95;
		if (items[5].scale) items[5].scale.x = 0.559;
		if (items[5].scale) items[5].scale.y = 0.559;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch","isButton":true,"option":"playground"});
	}
	if (items[6]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[6] as INellieBlyStoryLayout_blyDrZoom1);
		(items[6] as INellieBlyStoryLayout_blyDrZoom1).animation = "squishStretch";
		(items[6] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[6] as INellieBlyStoryLayout_blyDrZoom1).option = "playground";
		items[6].x = 760.85;
		items[6].y = 306.55;
		if (items[6].scale) items[6].scale.x = -0.560;
		if (items[6].scale) items[6].scale.y = 0.560;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch","isButton":true,"option":"moon"});
	}
	if (items[7]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[7] as INellieBlyStoryLayout_blyDrZoom1);
		(items[7] as INellieBlyStoryLayout_blyDrZoom1).animation = "squishStretch";
		(items[7] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[7] as INellieBlyStoryLayout_blyDrZoom1).option = "moon";
		items[7].x = 1431;
		items[7].y = 324.15;
		if (items[7].scale) items[7].scale.x = 0.560;
		if (items[7].scale) items[7].scale.y = 0.560;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"children:squishStretch appear delay=0.2","isButton":false,"option":"spaghetti"});
	}
	if (items[8]) {
		NellieBlyStoryLayout_slotRescueSpaghetti.call(items[8] as INellieBlyStoryLayout_slotRescueSpaghetti);
		(items[8] as INellieBlyStoryLayout_slotRescueSpaghetti).animation = "children:squishStretch appear delay=0.2";
		(items[8] as INellieBlyStoryLayout_slotRescueSpaghetti).isButton = false;
		(items[8] as INellieBlyStoryLayout_slotRescueSpaghetti).option = "spaghetti";
		items[8].x = 653.55;
		items[8].y = 1221.35;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"children:squishStretch appear delay=0.2","isButton":false,"option":"pyramid"});
	}
	if (items[9]) {
		NellieBlyStoryLayout_slotRescuePyramid.call(items[9] as INellieBlyStoryLayout_slotRescuePyramid);
		(items[9] as INellieBlyStoryLayout_slotRescuePyramid).animation = "children:squishStretch appear delay=0.2";
		(items[9] as INellieBlyStoryLayout_slotRescuePyramid).isButton = false;
		(items[9] as INellieBlyStoryLayout_slotRescuePyramid).option = "pyramid";
		items[9].x = 653.6;
		items[9].y = 1221.85;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"children:squishStretch appear delay=0.2","isButton":false,"option":"playground"});
	}
	if (items[10]) {
		NellieBlyStoryLayout_slotRescuePlayground.call(items[10] as INellieBlyStoryLayout_slotRescuePlayground);
		(items[10] as INellieBlyStoryLayout_slotRescuePlayground).animation = "children:squishStretch appear delay=0.2";
		(items[10] as INellieBlyStoryLayout_slotRescuePlayground).isButton = false;
		(items[10] as INellieBlyStoryLayout_slotRescuePlayground).option = "playground";
		items[10].x = 1768.55;
		items[10].y = 1221.9;
		if (items[10].scale) items[10].scale.x = -1.000;
		if (items[10].scale) items[10].scale.y = 1.000;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"children:squishStretch appear delay=0.2","isButton":false,"option":"moon"});
	}
	if (items[11]) {
		NellieBlyStoryLayout_slotRescueMoon.call(items[11] as INellieBlyStoryLayout_slotRescueMoon);
		(items[11] as INellieBlyStoryLayout_slotRescueMoon).animation = "children:squishStretch appear delay=0.2";
		(items[11] as INellieBlyStoryLayout_slotRescueMoon).isButton = false;
		(items[11] as INellieBlyStoryLayout_slotRescueMoon).option = "moon";
		items[11].x = 477.85;
		items[11].y = 1591.25;
		if (items[11].onLayout) items[11].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPlaygroundBg(this: INellieBlyStoryLayout_blyPlaygroundBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-bg.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_slotLand(this: INellieBlyStoryLayout_slotLand) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"spaghetti"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySpaghetti1.call(items[0] as INellieBlyStoryLayout_blySpaghetti1);
		(items[0] as INellieBlyStoryLayout_blySpaghetti1).animation = "";
		(items[0] as INellieBlyStoryLayout_blySpaghetti1).isButton = true;
		(items[0] as INellieBlyStoryLayout_blySpaghetti1).option = "spaghetti";
		items[0].x = 736.35;
		items[0].y = 122.65;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"pyramid"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyPyramid1.call(items[1] as INellieBlyStoryLayout_blyPyramid1);
		(items[1] as INellieBlyStoryLayout_blyPyramid1).animation = "";
		(items[1] as INellieBlyStoryLayout_blyPyramid1).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyPyramid1).option = "pyramid";
		items[1].x = -299.05;
		items[1].y = 365.45;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyPlayground.call(items[2] as INellieBlyStoryLayout_blyPlayground);
		(items[2] as INellieBlyStoryLayout_blyPlayground).animation = "";
		(items[2] as INellieBlyStoryLayout_blyPlayground).isButton = false;
		(items[2] as INellieBlyStoryLayout_blyPlayground).option = "playground";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"moon"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blySpace.call(items[3] as INellieBlyStoryLayout_blySpace);
		(items[3] as INellieBlyStoryLayout_blySpace).animation = "";
		(items[3] as INellieBlyStoryLayout_blySpace).isButton = false;
		(items[3] as INellieBlyStoryLayout_blySpace).option = "moon";
		items[3].x = 0;
		items[3].y = 0;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySpaghetti1(this: INellieBlyStoryLayout_blySpaghetti1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySpaghetti.call(items[0] as INellieBlyStoryLayout_blySpaghetti);
		items[0].x = 0;
		items[0].y = 79.9;
		items[0].width = 1267.00;
		items[0].height = 954.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySpaghetti(this: INellieBlyStoryLayout_blySpaghetti) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-spaghetti.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyPyramid1(this: INellieBlyStoryLayout_blyPyramid1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPyramid.call(items[0] as INellieBlyStoryLayout_blyPyramid);
		items[0].x = 0;
		items[0].y = 98.45;
		items[0].width = 2500.00;
		items[0].height = 687.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPyramid(this: INellieBlyStoryLayout_blyPyramid) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-pyramid.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyPlayground(this: INellieBlyStoryLayout_blyPlayground) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlayground41.call(items[0] as INellieBlyStoryLayout_blyPlayground41);
		(items[0] as INellieBlyStoryLayout_blyPlayground41).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPlayground41).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyPlayground41).option = "";
		items[0].x = 107.45;
		items[0].y = 1028.4;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyPlayground3.call(items[1] as INellieBlyStoryLayout_blyPlayground3);
		(items[1] as INellieBlyStoryLayout_blyPlayground3).animation = "";
		(items[1] as INellieBlyStoryLayout_blyPlayground3).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyPlayground3).option = "";
		items[1].x = 1713.15;
		items[1].y = 831.05;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyPlayground2.call(items[2] as INellieBlyStoryLayout_blyPlayground2);
		(items[2] as INellieBlyStoryLayout_blyPlayground2).animation = "";
		(items[2] as INellieBlyStoryLayout_blyPlayground2).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyPlayground2).option = "";
		items[2].x = 1115.2;
		items[2].y = 955.05;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":""});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blyPlayground1.call(items[3] as INellieBlyStoryLayout_blyPlayground1);
		(items[3] as INellieBlyStoryLayout_blyPlayground1).animation = "";
		(items[3] as INellieBlyStoryLayout_blyPlayground1).isButton = true;
		(items[3] as INellieBlyStoryLayout_blyPlayground1).option = "";
		items[3].x = 451.95;
		items[3].y = 125.6;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPlayground41(this: INellieBlyStoryLayout_blyPlayground41) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlayground4.call(items[0] as INellieBlyStoryLayout_blyPlayground4);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 470.00;
		items[0].height = 48.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPlayground4(this: INellieBlyStoryLayout_blyPlayground4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-4.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyPlayground3(this: INellieBlyStoryLayout_blyPlayground3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlayground31.call(items[0] as INellieBlyStoryLayout_blyPlayground31);
		items[0].x = 127.5;
		items[0].y = 142;
		items[0].width = 255.00;
		items[0].height = 284.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPlayground31(this: INellieBlyStoryLayout_blyPlayground31) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-3.png", 0.500, 0.500);
	return this;
}
function NellieBlyStoryLayout_blyPlayground2(this: INellieBlyStoryLayout_blyPlayground2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlayground21.call(items[0] as INellieBlyStoryLayout_blyPlayground21);
		items[0].x = 156.5;
		items[0].y = 72.5;
		items[0].width = 313.00;
		items[0].height = 145.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPlayground21(this: INellieBlyStoryLayout_blyPlayground21) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-2.png", 0.500, 0.500);
	return this;
}
function NellieBlyStoryLayout_blyPlayground1(this: INellieBlyStoryLayout_blyPlayground1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlayground11.call(items[0] as INellieBlyStoryLayout_blyPlayground11);
		items[0].x = 308;
		items[0].y = 498;
		items[0].width = 616.00;
		items[0].height = 996.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPlayground11(this: INellieBlyStoryLayout_blyPlayground11) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-playground-1.png", 0.500, 0.500);
	return this;
}
function NellieBlyStoryLayout_blySpace(this: INellieBlyStoryLayout_blySpace) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySpace3.call(items[0] as INellieBlyStoryLayout_blySpace3);
		(items[0] as INellieBlyStoryLayout_blySpace3).animation = "";
		(items[0] as INellieBlyStoryLayout_blySpace3).isButton = true;
		(items[0] as INellieBlyStoryLayout_blySpace3).option = "";
		items[0].x = 490.8;
		items[0].y = 247.25;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blySpace2.call(items[1] as INellieBlyStoryLayout_blySpace2);
		(items[1] as INellieBlyStoryLayout_blySpace2).animation = "";
		(items[1] as INellieBlyStoryLayout_blySpace2).isButton = true;
		(items[1] as INellieBlyStoryLayout_blySpace2).option = "";
		items[1].x = 1466.55;
		items[1].y = 586.7;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blySpace1.call(items[2] as INellieBlyStoryLayout_blySpace1);
		(items[2] as INellieBlyStoryLayout_blySpace1).animation = "";
		(items[2] as INellieBlyStoryLayout_blySpace1).isButton = true;
		(items[2] as INellieBlyStoryLayout_blySpace1).option = "";
		items[2].x = 342;
		items[2].y = 331.25;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySpace3(this: INellieBlyStoryLayout_blySpace3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyMoon1.call(items[0] as INellieBlyStoryLayout_blyMoon1);
		items[0].x = -44.5;
		items[0].y = -281.95;
		items[0].width = 305.00;
		items[0].height = 303.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMoon1(this: INellieBlyStoryLayout_blyMoon1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-moon-1.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blySpace2(this: INellieBlyStoryLayout_blySpace2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyMoon3.call(items[0] as INellieBlyStoryLayout_blyMoon3);
		items[0].x = -320.5;
		items[0].y = -320.5;
		items[0].width = 641.00;
		items[0].height = 641.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMoon3(this: INellieBlyStoryLayout_blyMoon3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-moon-3.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blySpace1(this: INellieBlyStoryLayout_blySpace1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyMoon2.call(items[0] as INellieBlyStoryLayout_blyMoon2);
		items[0].x = -260.45;
		items[0].y = 20;
		items[0].width = 433.00;
		items[0].height = 262.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMoon2(this: INellieBlyStoryLayout_blyMoon2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-moon-2.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyDrZoom1(this: INellieBlyStoryLayout_blyDrZoom1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyDrZoom11.call(items[0] as INellieBlyStoryLayout_blyDrZoom11);
		items[0].x = 0.5;
		items[0].y = 0;
		items[0].width = 277.00;
		items[0].height = 286.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyDrZoom11(this: INellieBlyStoryLayout_blyDrZoom11) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-dr-zoom-1.png", 0.502, 1.000);
	return this;
}
function NellieBlyStoryLayout_slotRescueSpaghetti(this: INellieBlyStoryLayout_slotRescueSpaghetti) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"boat"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBoat.call(items[0] as INellieBlyStoryLayout_blyBoat);
		(items[0] as INellieBlyStoryLayout_blyBoat).animation = "";
		(items[0] as INellieBlyStoryLayout_blyBoat).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyBoat).option = "boat";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"jetpack"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyJetpack.call(items[1] as INellieBlyStoryLayout_blyJetpack);
		(items[1] as INellieBlyStoryLayout_blyJetpack).animation = "";
		(items[1] as INellieBlyStoryLayout_blyJetpack).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyJetpack).option = "jetpack";
		items[1].x = 147.75;
		items[1].y = -594.35;
		if (items[1].scale) items[1].scale.x = 0.799;
		if (items[1].scale) items[1].scale.y = 0.799;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"bike"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyBike.call(items[2] as INellieBlyStoryLayout_blyBike);
		(items[2] as INellieBlyStoryLayout_blyBike).animation = "";
		(items[2] as INellieBlyStoryLayout_blyBike).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyBike).option = "bike";
		items[2].x = 83.4;
		items[2].y = -53.2;
		if (items[2].scale) items[2].scale.x = 0.810;
		if (items[2].scale) items[2].scale.y = 0.810;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"skates"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blyRollerskate1.call(items[3] as INellieBlyStoryLayout_blyRollerskate1);
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).animation = "";
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).isButton = true;
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).option = "skates";
		items[3].x = 92.75;
		items[3].y = 25.85;
		if (items[3].scale) items[3].scale.x = 0.846;
		if (items[3].scale) items[3].scale.y = 0.846;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotRescuePyramid(this: INellieBlyStoryLayout_slotRescuePyramid) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"boat"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBoat.call(items[0] as INellieBlyStoryLayout_blyBoat);
		(items[0] as INellieBlyStoryLayout_blyBoat).animation = "";
		(items[0] as INellieBlyStoryLayout_blyBoat).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyBoat).option = "boat";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"jetpack"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyJetpack.call(items[1] as INellieBlyStoryLayout_blyJetpack);
		(items[1] as INellieBlyStoryLayout_blyJetpack).animation = "";
		(items[1] as INellieBlyStoryLayout_blyJetpack).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyJetpack).option = "jetpack";
		items[1].x = 147.75;
		items[1].y = -594.35;
		if (items[1].scale) items[1].scale.x = 0.799;
		if (items[1].scale) items[1].scale.y = 0.799;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"bike"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyBike.call(items[2] as INellieBlyStoryLayout_blyBike);
		(items[2] as INellieBlyStoryLayout_blyBike).animation = "";
		(items[2] as INellieBlyStoryLayout_blyBike).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyBike).option = "bike";
		items[2].x = 115.4;
		items[2].y = -13.2;
		if (items[2].scale) items[2].scale.x = 0.810;
		if (items[2].scale) items[2].scale.y = 0.810;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"skates"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blyRollerskate1.call(items[3] as INellieBlyStoryLayout_blyRollerskate1);
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).animation = "";
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).isButton = true;
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).option = "skates";
		items[3].x = 143.95;
		items[3].y = -6.15;
		if (items[3].scale) items[3].scale.x = 0.846;
		if (items[3].scale) items[3].scale.y = 0.846;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotRescuePlayground(this: INellieBlyStoryLayout_slotRescuePlayground) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"boat"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBoat.call(items[0] as INellieBlyStoryLayout_blyBoat);
		(items[0] as INellieBlyStoryLayout_blyBoat).animation = "";
		(items[0] as INellieBlyStoryLayout_blyBoat).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyBoat).option = "boat";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"jetpack"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyJetpack.call(items[1] as INellieBlyStoryLayout_blyJetpack);
		(items[1] as INellieBlyStoryLayout_blyJetpack).animation = "";
		(items[1] as INellieBlyStoryLayout_blyJetpack).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyJetpack).option = "jetpack";
		items[1].x = 209.6;
		items[1].y = -721.05;
		if (items[1].scale) items[1].scale.x = 0.799;
		if (items[1].scale) items[1].scale.y = 0.799;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"bike"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyBike.call(items[2] as INellieBlyStoryLayout_blyBike);
		(items[2] as INellieBlyStoryLayout_blyBike).animation = "";
		(items[2] as INellieBlyStoryLayout_blyBike).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyBike).option = "bike";
		items[2].x = 194.8;
		items[2].y = -7.25;
		if (items[2].scale) items[2].scale.x = 0.810;
		if (items[2].scale) items[2].scale.y = 0.810;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"skates"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blyRollerskate1.call(items[3] as INellieBlyStoryLayout_blyRollerskate1);
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).animation = "";
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).isButton = true;
		(items[3] as INellieBlyStoryLayout_blyRollerskate1).option = "skates";
		items[3].x = 182.85;
		items[3].y = 5.65;
		if (items[3].scale) items[3].scale.x = 0.846;
		if (items[3].scale) items[3].scale.y = 0.846;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotRescueMoon(this: INellieBlyStoryLayout_slotRescueMoon) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"boat"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBoat1.call(items[0] as INellieBlyStoryLayout_blyBoat1);
		(items[0] as INellieBlyStoryLayout_blyBoat1).animation = "";
		(items[0] as INellieBlyStoryLayout_blyBoat1).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyBoat1).option = "boat";
		items[0].x = 0;
		items[0].y = -445.5;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"jetpack"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyJetpack2.call(items[1] as INellieBlyStoryLayout_blyJetpack2);
		(items[1] as INellieBlyStoryLayout_blyJetpack2).animation = "";
		(items[1] as INellieBlyStoryLayout_blyJetpack2).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyJetpack2).option = "jetpack";
		items[1].x = 300.05;
		items[1].y = -737.5;
		items[1].rotation = 0.1007;
		if (items[1].scale) items[1].scale.x = 0.635;
		if (items[1].scale) items[1].scale.y = 0.635;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"bike"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyBike1.call(items[2] as INellieBlyStoryLayout_blyBike1);
		(items[2] as INellieBlyStoryLayout_blyBike1).animation = "";
		(items[2] as INellieBlyStoryLayout_blyBike1).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyBike1).option = "bike";
		items[2].x = 246.55;
		items[2].y = -756.7;
		items[2].rotation = 2.4985;
		if (items[2].scale) items[2].scale.x = 0.659;
		if (items[2].scale) items[2].scale.y = 0.659;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"skates"});
	}
	if (items[3]) {
		NellieBlyStoryLayout_blyRollerskate2.call(items[3] as INellieBlyStoryLayout_blyRollerskate2);
		(items[3] as INellieBlyStoryLayout_blyRollerskate2).animation = "";
		(items[3] as INellieBlyStoryLayout_blyRollerskate2).isButton = true;
		(items[3] as INellieBlyStoryLayout_blyRollerskate2).option = "skates";
		items[3].x = 314.05;
		items[3].y = -734.8;
		items[3].rotation = -0.4228;
		if (items[3].scale) items[3].scale.x = 0.602;
		if (items[3].scale) items[3].scale.y = 0.602;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBoat1(this: INellieBlyStoryLayout_blyBoat1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBoatBack.call(items[0] as INellieBlyStoryLayout_blyBoatBack);
		items[0].x = -387.5;
		items[0].y = -445.5;
		items[0].width = 775.00;
		items[0].height = 891.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyJetpack2(this: INellieBlyStoryLayout_blyJetpack2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"rotate time=14","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyJetpack1.call(items[0] as INellieBlyStoryLayout_blyJetpack1);
		(items[0] as INellieBlyStoryLayout_blyJetpack1).animation = "rotate time=14";
		(items[0] as INellieBlyStoryLayout_blyJetpack1).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyJetpack1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 636.00;
		items[0].height = 684.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBike1(this: INellieBlyStoryLayout_blyBike1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"rotate time=14","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBicycle3.call(items[0] as INellieBlyStoryLayout_blyBicycle3);
		(items[0] as INellieBlyStoryLayout_blyBicycle3).animation = "rotate time=14";
		(items[0] as INellieBlyStoryLayout_blyBicycle3).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyBicycle3).option = "";
		items[0].x = 26.85;
		items[0].y = 59.9;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBicycle3(this: INellieBlyStoryLayout_blyBicycle3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBicycle2.call(items[0] as INellieBlyStoryLayout_blyBicycle2);
		items[0].x = -26.35;
		items[0].y = 273.6;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyBicycle2(this: INellieBlyStoryLayout_blyBicycle2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyBicycle1.call(items[0] as INellieBlyStoryLayout_blyBicycle1);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 449.00;
		items[0].height = 667.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyRollerskate2(this: INellieBlyStoryLayout_blyRollerskate2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"rotate time=14","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyRollerskate3.call(items[0] as INellieBlyStoryLayout_blyRollerskate3);
		(items[0] as INellieBlyStoryLayout_blyRollerskate3).animation = "rotate time=14";
		(items[0] as INellieBlyStoryLayout_blyRollerskate3).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyRollerskate3).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyRollerskate3(this: INellieBlyStoryLayout_blyRollerskate3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyRollerskate.call(items[0] as INellieBlyStoryLayout_blyRollerskate);
		(items[0] as INellieBlyStoryLayout_blyRollerskate).animation = "";
		(items[0] as INellieBlyStoryLayout_blyRollerskate).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyRollerskate).option = "";
		items[0].x = 0;
		items[0].y = 342.5;
		items[0].width = 638.00;
		items[0].height = 685.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
export function NellieBlyStoryLayout_scene5Speech(this: INellieBlyStoryLayout_scene5Speech) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlaygroundBg.call(items[0] as INellieBlyStoryLayout_blyPlaygroundBg);
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).option = "playground";
		items[0].x = 84.3;
		items[0].y = 29.85;
		items[0].width = 1708.00;
		items[0].height = 998.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		NellieBlyStoryLayout_paperLayer.call(items[1] as INellieBlyStoryLayout_paperLayer);
		(items[1] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		NellieBlyStoryLayout_slotLand.call(items[2] as INellieBlyStoryLayout_slotLand);
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		NellieBlyStoryLayout_paperLayer.call(items[3] as INellieBlyStoryLayout_paperLayer);
		(items[3] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		NellieBlyStoryLayout_slotClimbSpaghetti.call(items[4] as INellieBlyStoryLayout_slotClimbSpaghetti);
		items[4].x = 425.95;
		items[4].y = 508.1;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		NellieBlyStoryLayout_slotClimbPyramid.call(items[5] as INellieBlyStoryLayout_slotClimbPyramid);
		items[5].x = 1205.5;
		items[5].y = 555.5;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		NellieBlyStoryLayout_slotClimbPlayground.call(items[6] as INellieBlyStoryLayout_slotClimbPlayground);
		items[6].x = 760;
		items[6].y = 465.6;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		NellieBlyStoryLayout_slotClimbMoon.call(items[7] as INellieBlyStoryLayout_slotClimbMoon);
		items[7].x = 393.25;
		items[7].y = 452.7;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"isPaperLayer":true});
	}
	if (items[8]) {
		NellieBlyStoryLayout_paperLayer.call(items[8] as INellieBlyStoryLayout_paperLayer);
		(items[8] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[8].x = 0;
		items[8].y = 0;
		items[8].width = 2048.00;
		items[8].height = 1536.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":false,"option":"spaghetti pizzastairs"});
	}
	if (items[9]) {
		NellieBlyStoryLayout_slotHero.call(items[9] as INellieBlyStoryLayout_slotHero);
		(items[9] as INellieBlyStoryLayout_slotHero).animation = "";
		(items[9] as INellieBlyStoryLayout_slotHero).isButton = false;
		(items[9] as INellieBlyStoryLayout_slotHero).option = "spaghetti pizzastairs";
		items[9].x = 1142.3;
		items[9].y = 556.75;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"","isButton":false,"option":"spaghetti monkeybars"});
	}
	if (items[10]) {
		NellieBlyStoryLayout_slotHero.call(items[10] as INellieBlyStoryLayout_slotHero);
		(items[10] as INellieBlyStoryLayout_slotHero).animation = "";
		(items[10] as INellieBlyStoryLayout_slotHero).isButton = false;
		(items[10] as INellieBlyStoryLayout_slotHero).option = "spaghetti monkeybars";
		items[10].x = 1173.8;
		items[10].y = 648.1;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"","isButton":false,"option":"spaghetti ladder"});
	}
	if (items[11]) {
		NellieBlyStoryLayout_slotHero.call(items[11] as INellieBlyStoryLayout_slotHero);
		(items[11] as INellieBlyStoryLayout_slotHero).animation = "";
		(items[11] as INellieBlyStoryLayout_slotHero).isButton = false;
		(items[11] as INellieBlyStoryLayout_slotHero).option = "spaghetti ladder";
		items[11].x = 1200.6;
		items[11].y = 725.6;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"squishStretch","isButton":true,"option":"pyramid monkeybars"});
	}
	if (items[12]) {
		NellieBlyStoryLayout_blyYHero1.call(items[12] as INellieBlyStoryLayout_blyYHero1);
		(items[12] as INellieBlyStoryLayout_blyYHero1).animation = "squishStretch";
		(items[12] as INellieBlyStoryLayout_blyYHero1).isButton = true;
		(items[12] as INellieBlyStoryLayout_blyYHero1).option = "pyramid monkeybars";
		items[12].x = 1439.4;
		items[12].y = 690.5;
		if (items[12].scale) items[12].scale.x = -1.000;
		if (items[12].scale) items[12].scale.y = 1.000;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"squishStretch","isButton":true,"option":"pyramid ladder"});
	}
	if (items[13]) {
		NellieBlyStoryLayout_blyYHero1.call(items[13] as INellieBlyStoryLayout_blyYHero1);
		(items[13] as INellieBlyStoryLayout_blyYHero1).animation = "squishStretch";
		(items[13] as INellieBlyStoryLayout_blyYHero1).isButton = true;
		(items[13] as INellieBlyStoryLayout_blyYHero1).option = "pyramid ladder";
		items[13].x = 1451.6;
		items[13].y = 677.5;
		if (items[13].scale) items[13].scale.x = -1.000;
		if (items[13].scale) items[13].scale.y = 1.000;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"squishStretch","isButton":true,"option":"pyramid pizzastairs"});
	}
	if (items[14]) {
		NellieBlyStoryLayout_blyYHero1.call(items[14] as INellieBlyStoryLayout_blyYHero1);
		(items[14] as INellieBlyStoryLayout_blyYHero1).animation = "squishStretch";
		(items[14] as INellieBlyStoryLayout_blyYHero1).isButton = true;
		(items[14] as INellieBlyStoryLayout_blyYHero1).option = "pyramid pizzastairs";
		items[14].x = 1486;
		items[14].y = 592.45;
		if (items[14].scale) items[14].scale.x = -1.000;
		if (items[14].scale) items[14].scale.y = 1.000;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"squishStretch","isButton":true,"option":"playground monkeybars"});
	}
	if (items[15]) {
		NellieBlyStoryLayout_blyYHero1.call(items[15] as INellieBlyStoryLayout_blyYHero1);
		(items[15] as INellieBlyStoryLayout_blyYHero1).animation = "squishStretch";
		(items[15] as INellieBlyStoryLayout_blyYHero1).isButton = true;
		(items[15] as INellieBlyStoryLayout_blyYHero1).option = "playground monkeybars";
		items[15].x = 1022.1;
		items[15].y = 613.8;
		if (items[15].scale) items[15].scale.x = -1.000;
		if (items[15].scale) items[15].scale.y = 1.000;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"squishStretch","isButton":true,"option":"playground ladder"});
	}
	if (items[16]) {
		NellieBlyStoryLayout_blyYHero1.call(items[16] as INellieBlyStoryLayout_blyYHero1);
		(items[16] as INellieBlyStoryLayout_blyYHero1).animation = "squishStretch";
		(items[16] as INellieBlyStoryLayout_blyYHero1).isButton = true;
		(items[16] as INellieBlyStoryLayout_blyYHero1).option = "playground ladder";
		items[16].x = 998.75;
		items[16].y = 579.25;
		if (items[16].scale) items[16].scale.x = -1.000;
		if (items[16].scale) items[16].scale.y = 1.000;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"squishStretch","isButton":true,"option":"playground pizzastairs"});
	}
	if (items[17]) {
		NellieBlyStoryLayout_blyYHero1.call(items[17] as INellieBlyStoryLayout_blyYHero1);
		(items[17] as INellieBlyStoryLayout_blyYHero1).animation = "squishStretch";
		(items[17] as INellieBlyStoryLayout_blyYHero1).isButton = true;
		(items[17] as INellieBlyStoryLayout_blyYHero1).option = "playground pizzastairs";
		items[17].x = 1040.3;
		items[17].y = 502.15;
		if (items[17].scale) items[17].scale.x = -1.000;
		if (items[17].scale) items[17].scale.y = 1.000;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,{"animation":"","isButton":false,"option":"moon pizzastairs"});
	}
	if (items[18]) {
		NellieBlyStoryLayout_slotHero.call(items[18] as INellieBlyStoryLayout_slotHero);
		(items[18] as INellieBlyStoryLayout_slotHero).animation = "";
		(items[18] as INellieBlyStoryLayout_slotHero).isButton = false;
		(items[18] as INellieBlyStoryLayout_slotHero).option = "moon pizzastairs";
		items[18].x = 1108.75;
		items[18].y = 502.25;
		if (items[18].onLayout) items[18].onLayout();
	}
	if (!items[19] && items.elementFactory) {
		items[19] = items.elementFactory(19,{"animation":"","isButton":false,"option":"moon monkeybars"});
	}
	if (items[19]) {
		NellieBlyStoryLayout_slotHero.call(items[19] as INellieBlyStoryLayout_slotHero);
		(items[19] as INellieBlyStoryLayout_slotHero).animation = "";
		(items[19] as INellieBlyStoryLayout_slotHero).isButton = false;
		(items[19] as INellieBlyStoryLayout_slotHero).option = "moon monkeybars";
		items[19].x = 1126.25;
		items[19].y = 585.35;
		if (items[19].onLayout) items[19].onLayout();
	}
	if (!items[20] && items.elementFactory) {
		items[20] = items.elementFactory(20,{"animation":"","isButton":false,"option":"moon ladder"});
	}
	if (items[20]) {
		NellieBlyStoryLayout_slotHero.call(items[20] as INellieBlyStoryLayout_slotHero);
		(items[20] as INellieBlyStoryLayout_slotHero).animation = "";
		(items[20] as INellieBlyStoryLayout_slotHero).isButton = false;
		(items[20] as INellieBlyStoryLayout_slotHero).option = "moon ladder";
		items[20].x = 1136.7;
		items[20].y = 610.1;
		if (items[20].onLayout) items[20].onLayout();
	}
	if (!items[21] && items.elementFactory) {
		items[21] = items.elementFactory(21,{"animation":"","isButton":true,"option":"spaghetti"});
	}
	if (items[21]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[21] as INellieBlyStoryLayout_blyDrZoom1);
		(items[21] as INellieBlyStoryLayout_blyDrZoom1).animation = "";
		(items[21] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[21] as INellieBlyStoryLayout_blyDrZoom1).option = "spaghetti";
		items[21].x = 1438.55;
		items[21].y = 282.15;
		if (items[21].scale) items[21].scale.x = 0.560;
		if (items[21].scale) items[21].scale.y = 0.560;
		if (items[21].onLayout) items[21].onLayout();
	}
	if (!items[22] && items.elementFactory) {
		items[22] = items.elementFactory(22,{"animation":"","isButton":true,"option":"pyramid"});
	}
	if (items[22]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[22] as INellieBlyStoryLayout_blyDrZoom1);
		(items[22] as INellieBlyStoryLayout_blyDrZoom1).animation = "";
		(items[22] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[22] as INellieBlyStoryLayout_blyDrZoom1).option = "pyramid";
		items[22].x = 1234.15;
		items[22].y = 524.95;
		if (items[22].scale) items[22].scale.x = 0.559;
		if (items[22].scale) items[22].scale.y = 0.559;
		if (items[22].onLayout) items[22].onLayout();
	}
	if (!items[23] && items.elementFactory) {
		items[23] = items.elementFactory(23,{"animation":"squishStretch","isButton":true,"option":"playground"});
	}
	if (items[23]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[23] as INellieBlyStoryLayout_blyDrZoom1);
		(items[23] as INellieBlyStoryLayout_blyDrZoom1).animation = "squishStretch";
		(items[23] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[23] as INellieBlyStoryLayout_blyDrZoom1).option = "playground";
		items[23].x = 760.85;
		items[23].y = 306.55;
		if (items[23].scale) items[23].scale.x = -0.560;
		if (items[23].scale) items[23].scale.y = 0.560;
		if (items[23].onLayout) items[23].onLayout();
	}
	if (!items[24] && items.elementFactory) {
		items[24] = items.elementFactory(24,{"animation":"","isButton":true,"option":"moon"});
	}
	if (items[24]) {
		NellieBlyStoryLayout_blyDrZoom1.call(items[24] as INellieBlyStoryLayout_blyDrZoom1);
		(items[24] as INellieBlyStoryLayout_blyDrZoom1).animation = "";
		(items[24] as INellieBlyStoryLayout_blyDrZoom1).isButton = true;
		(items[24] as INellieBlyStoryLayout_blyDrZoom1).option = "moon";
		items[24].x = 1431;
		items[24].y = 324.15;
		if (items[24].scale) items[24].scale.x = 0.560;
		if (items[24].scale) items[24].scale.y = 0.560;
		if (items[24].onLayout) items[24].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotClimbSpaghetti(this: INellieBlyStoryLayout_slotClimbSpaghetti) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"spaghetti pizzastairs"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPizzastairsYadina1.call(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1);
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1).option = "spaghetti pizzastairs";
		items[0].x = 0;
		items[0].y = 13.2;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"spaghetti monkeybars"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyMonkeyBarSpaghetti.call(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti);
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti).animation = "";
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti).option = "spaghetti monkeybars";
		items[1].x = 307;
		items[1].y = 30.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"spaghetti ladder"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyLadderYadina1.call(items[2] as INellieBlyStoryLayout_blyLadderYadina1);
		(items[2] as INellieBlyStoryLayout_blyLadderYadina1).animation = "";
		(items[2] as INellieBlyStoryLayout_blyLadderYadina1).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyLadderYadina1).option = "spaghetti ladder";
		items[2].x = 1016.4;
		items[2].y = 76.4;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPizzastairsYadina1(this: INellieBlyStoryLayout_blyPizzastairsYadina1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPizzastairs.call(items[0] as INellieBlyStoryLayout_blyPizzastairs);
		items[0].x = 994;
		items[0].y = 0;
		items[0].width = -994.00;
		items[0].height = 736.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPizzastairs(this: INellieBlyStoryLayout_blyPizzastairs) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-pizzastairs.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyMonkeyBarSpaghetti(this: INellieBlyStoryLayout_blyMonkeyBarSpaghetti) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyMonkeyBars.call(items[0] as INellieBlyStoryLayout_blyMonkeyBars);
		items[0].x = 38.05;
		items[0].y = 0;
		items[0].width = 701.00;
		items[0].height = 641.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyLandingPad.call(items[1] as INellieBlyStoryLayout_blyLandingPad);
		items[1].x = 0;
		items[1].y = 600.45;
		items[1].width = 325.00;
		items[1].height = 65.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMonkeyBars(this: INellieBlyStoryLayout_blyMonkeyBars) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-monkey-bars.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyLandingPad(this: INellieBlyStoryLayout_blyLandingPad) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-landing-pad.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyLadderYadina1(this: INellieBlyStoryLayout_blyLadderYadina1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyLadder1.call(items[0] as INellieBlyStoryLayout_blyLadder1);
		items[0].x = 0;
		items[0].y = 0;
		items[0].rotation = 0.1745;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyLadder1(this: INellieBlyStoryLayout_blyLadder1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyLadder.call(items[0] as INellieBlyStoryLayout_blyLadder);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = -433.00;
		items[0].height = 648.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyLadder(this: INellieBlyStoryLayout_blyLadder) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-ladder.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_slotClimbPyramid(this: INellieBlyStoryLayout_slotClimbPyramid) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"pyramid pizzastairs"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPizzastairsYadina.call(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina);
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina).option = "pyramid pizzastairs";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"pyramid monkeybars"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyMonkeyBarsPyramid.call(items[1] as INellieBlyStoryLayout_blyMonkeyBarsPyramid);
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarsPyramid).animation = "";
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarsPyramid).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarsPyramid).option = "pyramid monkeybars";
		items[1].x = -69.4;
		items[1].y = 20.4;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"pyramid ladder"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyLadderYadina2.call(items[2] as INellieBlyStoryLayout_blyLadderYadina2);
		(items[2] as INellieBlyStoryLayout_blyLadderYadina2).animation = "";
		(items[2] as INellieBlyStoryLayout_blyLadderYadina2).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyLadderYadina2).option = "pyramid ladder";
		items[2].x = 59;
		items[2].y = 63.35;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyPizzastairsYadina(this: INellieBlyStoryLayout_blyPizzastairsYadina) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPizzastairs.call(items[0] as INellieBlyStoryLayout_blyPizzastairs);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 994.00;
		items[0].height = 736.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMonkeyBarsPyramid(this: INellieBlyStoryLayout_blyMonkeyBarsPyramid) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyMonkeyBarsPyramid1.call(items[0] as INellieBlyStoryLayout_blyMonkeyBarsPyramid1);
		items[0].x = 739.05;
		items[0].y = 0;
		if (items[0].scale) items[0].scale.x = -1.000;
		if (items[0].scale) items[0].scale.y = 1.000;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMonkeyBarsPyramid1(this: INellieBlyStoryLayout_blyMonkeyBarsPyramid1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyMonkeyBars.call(items[0] as INellieBlyStoryLayout_blyMonkeyBars);
		items[0].x = 38.05;
		items[0].y = 0;
		items[0].width = 701.00;
		items[0].height = 641.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyLandingPad.call(items[1] as INellieBlyStoryLayout_blyLandingPad);
		items[1].x = 0;
		items[1].y = 600.45;
		items[1].width = 325.00;
		items[1].height = 65.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyLadderYadina2(this: INellieBlyStoryLayout_blyLadderYadina2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyLadder.call(items[0] as INellieBlyStoryLayout_blyLadder);
		items[0].x = 0;
		items[0].y = 0;
		items[0].rotation = -0.1758;
		items[0].width = 433.00;
		items[0].height = 648.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotClimbPlayground(this: INellieBlyStoryLayout_slotClimbPlayground) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"playground pizzastairs"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPizzastairsYadina.call(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina);
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina).option = "playground pizzastairs";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"playground monkeybars"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina.call(items[1] as INellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina);
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina).animation = "";
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina).option = "playground monkeybars";
		items[1].x = 58.9;
		items[1].y = 64.15;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"playground ladder"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyLadderYadina.call(items[2] as INellieBlyStoryLayout_blyLadderYadina);
		(items[2] as INellieBlyStoryLayout_blyLadderYadina).animation = "";
		(items[2] as INellieBlyStoryLayout_blyLadderYadina).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyLadderYadina).option = "playground ladder";
		items[2].x = 62.3;
		items[2].y = 19.2;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina(this: INellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyMonkeyBars1.call(items[0] as INellieBlyStoryLayout_blyMonkeyBars1);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 531.00;
		items[0].height = 594.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyLandingPad.call(items[1] as INellieBlyStoryLayout_blyLandingPad);
		items[1].x = 330.95;
		items[1].y = 548.55;
		items[1].width = 272.39;
		items[1].height = 54.48;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyMonkeyBars1(this: INellieBlyStoryLayout_blyMonkeyBars1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-monkey-bars-1.png", 0.000, 0.000);
	return this;
}
function NellieBlyStoryLayout_blyLadderYadina(this: INellieBlyStoryLayout_blyLadderYadina) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyLadder.call(items[0] as INellieBlyStoryLayout_blyLadder);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 433.00;
		items[0].height = 648.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotClimbMoon(this: INellieBlyStoryLayout_slotClimbMoon) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"moon pizzastairs"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPizzastairsYadina1.call(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1);
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyPizzastairsYadina1).option = "moon pizzastairs";
		items[0].x = 0;
		items[0].y = 13.2;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"moon monkeybars"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyMonkeyBarSpaghetti.call(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti);
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti).animation = "";
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyMonkeyBarSpaghetti).option = "moon monkeybars";
		items[1].x = 300;
		items[1].y = 20.85;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"moon ladder"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyLadderYadina1.call(items[2] as INellieBlyStoryLayout_blyLadderYadina1);
		(items[2] as INellieBlyStoryLayout_blyLadderYadina1).animation = "";
		(items[2] as INellieBlyStoryLayout_blyLadderYadina1).isButton = true;
		(items[2] as INellieBlyStoryLayout_blyLadderYadina1).option = "moon ladder";
		items[2].x = 981.4;
		items[2].y = 16.4;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotHero(this: INellieBlyStoryLayout_slotHero) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":true,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYHero1.call(items[0] as INellieBlyStoryLayout_blyYHero1);
		(items[0] as INellieBlyStoryLayout_blyYHero1).animation = "squishStretch";
		(items[0] as INellieBlyStoryLayout_blyYHero1).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyYHero1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYHero1(this: INellieBlyStoryLayout_blyYHero1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYHero.call(items[0] as INellieBlyStoryLayout_blyYHero);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 437.38;
		items[0].height = 456.01;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYHero(this: INellieBlyStoryLayout_blyYHero) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-hero.png", 0.500, 1.000);
	return this;
}
export function NellieBlyStoryLayout_scene6End(this: INellieBlyStoryLayout_scene6End) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyPlaygroundBg.call(items[0] as INellieBlyStoryLayout_blyPlaygroundBg);
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).animation = "";
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyPlaygroundBg).option = "playground";
		items[0].x = 84.3;
		items[0].y = 29.85;
		items[0].width = 1708.00;
		items[0].height = 998.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"isPaperLayer":true});
	}
	if (items[1]) {
		NellieBlyStoryLayout_paperLayer.call(items[1] as INellieBlyStoryLayout_paperLayer);
		(items[1] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 2048.00;
		items[1].height = 1536.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		NellieBlyStoryLayout_slotLand.call(items[2] as INellieBlyStoryLayout_slotLand);
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		NellieBlyStoryLayout_paperLayer.call(items[3] as INellieBlyStoryLayout_paperLayer);
		(items[3] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		NellieBlyStoryLayout_slotClimbSpaghetti.call(items[4] as INellieBlyStoryLayout_slotClimbSpaghetti);
		items[4].x = 425.95;
		items[4].y = 508.1;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		NellieBlyStoryLayout_slotClimbPyramid.call(items[5] as INellieBlyStoryLayout_slotClimbPyramid);
		items[5].x = 1205.5;
		items[5].y = 555.5;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		NellieBlyStoryLayout_slotClimbPlayground.call(items[6] as INellieBlyStoryLayout_slotClimbPlayground);
		items[6].x = 760;
		items[6].y = 465.6;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		NellieBlyStoryLayout_slotClimbMoon.call(items[7] as INellieBlyStoryLayout_slotClimbMoon);
		items[7].x = 393.25;
		items[7].y = 452.7;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"isPaperLayer":true});
	}
	if (items[8]) {
		NellieBlyStoryLayout_paperLayer.call(items[8] as INellieBlyStoryLayout_paperLayer);
		(items[8] as INellieBlyStoryLayout_paperLayer).isPaperLayer = true;
		items[8].x = 0;
		items[8].y = 0;
		items[8].width = 2048.00;
		items[8].height = 1536.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":false,"option":"spaghetti"});
	}
	if (items[9]) {
		NellieBlyStoryLayout_slotEnd.call(items[9] as INellieBlyStoryLayout_slotEnd);
		(items[9] as INellieBlyStoryLayout_slotEnd).animation = "";
		(items[9] as INellieBlyStoryLayout_slotEnd).isButton = false;
		(items[9] as INellieBlyStoryLayout_slotEnd).option = "spaghetti";
		items[9].x = 838.4;
		items[9].y = 1273.45;
		if (items[9].scale) items[9].scale.x = -1.000;
		if (items[9].scale) items[9].scale.y = 1.000;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"","isButton":false,"option":"pyramid"});
	}
	if (items[10]) {
		NellieBlyStoryLayout_slotEnd.call(items[10] as INellieBlyStoryLayout_slotEnd);
		(items[10] as INellieBlyStoryLayout_slotEnd).animation = "";
		(items[10] as INellieBlyStoryLayout_slotEnd).isButton = false;
		(items[10] as INellieBlyStoryLayout_slotEnd).option = "pyramid";
		items[10].x = 906.15;
		items[10].y = 1221.5;
		if (items[10].scale) items[10].scale.x = -1.000;
		if (items[10].scale) items[10].scale.y = 1.000;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"","isButton":false,"option":"playground"});
	}
	if (items[11]) {
		NellieBlyStoryLayout_slotEnd.call(items[11] as INellieBlyStoryLayout_slotEnd);
		(items[11] as INellieBlyStoryLayout_slotEnd).animation = "";
		(items[11] as INellieBlyStoryLayout_slotEnd).isButton = false;
		(items[11] as INellieBlyStoryLayout_slotEnd).option = "playground";
		items[11].x = 1343.25;
		items[11].y = 1219.4;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"","isButton":false,"option":"moon"});
	}
	if (items[12]) {
		NellieBlyStoryLayout_slotEnd.call(items[12] as INellieBlyStoryLayout_slotEnd);
		(items[12] as INellieBlyStoryLayout_slotEnd).animation = "";
		(items[12] as INellieBlyStoryLayout_slotEnd).isButton = false;
		(items[12] as INellieBlyStoryLayout_slotEnd).option = "moon";
		items[12].x = 808.1;
		items[12].y = 1218.45;
		if (items[12].scale) items[12].scale.x = -1.000;
		if (items[12].scale) items[12].scale.y = 1.000;
		if (items[12].onLayout) items[12].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_slotEnd(this: INellieBlyStoryLayout_slotEnd) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":true,"option":"hug"});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYHug1.call(items[0] as INellieBlyStoryLayout_blyYHug1);
		(items[0] as INellieBlyStoryLayout_blyYHug1).animation = "squishStretch";
		(items[0] as INellieBlyStoryLayout_blyYHug1).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyYHug1).option = "hug";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch","isButton":true,"option":"kiss"});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyYKiss1.call(items[1] as INellieBlyStoryLayout_blyYKiss1);
		(items[1] as INellieBlyStoryLayout_blyYKiss1).animation = "squishStretch";
		(items[1] as INellieBlyStoryLayout_blyYKiss1).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyYKiss1).option = "kiss";
		items[1].x = 0;
		items[1].y = 0;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"snack"});
	}
	if (items[2]) {
		NellieBlyStoryLayout_blyYSnack.call(items[2] as INellieBlyStoryLayout_blyYSnack);
		(items[2] as INellieBlyStoryLayout_blyYSnack).animation = "";
		(items[2] as INellieBlyStoryLayout_blyYSnack).isButton = false;
		(items[2] as INellieBlyStoryLayout_blyYSnack).option = "snack";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYHug1(this: INellieBlyStoryLayout_blyYHug1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYHug.call(items[0] as INellieBlyStoryLayout_blyYHug);
		(items[0] as INellieBlyStoryLayout_blyYHug).animation = "";
		(items[0] as INellieBlyStoryLayout_blyYHug).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyYHug).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 542.00;
		items[0].height = 623.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYHug(this: INellieBlyStoryLayout_blyYHug) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-hug.png", 0.500, 1.000);
	return this;
}
function NellieBlyStoryLayout_blyYKiss1(this: INellieBlyStoryLayout_blyYKiss1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYKiss.call(items[0] as INellieBlyStoryLayout_blyYKiss);
		(items[0] as INellieBlyStoryLayout_blyYKiss).animation = "";
		(items[0] as INellieBlyStoryLayout_blyYKiss).isButton = false;
		(items[0] as INellieBlyStoryLayout_blyYKiss).option = "";
		items[0].x = 0.5;
		items[0].y = 0;
		items[0].width = 533.00;
		items[0].height = 611.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYKiss(this: INellieBlyStoryLayout_blyYKiss) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-kiss.png", 0.501, 1.000);
	return this;
}
function NellieBlyStoryLayout_blyYSnack(this: INellieBlyStoryLayout_blyYSnack) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":true,"option":""});
	}
	if (items[0]) {
		NellieBlyStoryLayout_blyYSnack2.call(items[0] as INellieBlyStoryLayout_blyYSnack2);
		(items[0] as INellieBlyStoryLayout_blyYSnack2).animation = "squishStretch";
		(items[0] as INellieBlyStoryLayout_blyYSnack2).isButton = true;
		(items[0] as INellieBlyStoryLayout_blyYSnack2).option = "";
		items[0].x = -0.5;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch appear delay=0.1","isButton":true,"option":""});
	}
	if (items[1]) {
		NellieBlyStoryLayout_blyYSnackDrzoom.call(items[1] as INellieBlyStoryLayout_blyYSnackDrzoom);
		(items[1] as INellieBlyStoryLayout_blyYSnackDrzoom).animation = "squishStretch appear delay=0.1";
		(items[1] as INellieBlyStoryLayout_blyYSnackDrzoom).isButton = true;
		(items[1] as INellieBlyStoryLayout_blyYSnackDrzoom).option = "";
		items[1].x = -239;
		items[1].y = 5;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blyYSnack2(this: INellieBlyStoryLayout_blyYSnack2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySnack3.call(items[0] as INellieBlyStoryLayout_blySnack3);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 577.00;
		items[0].height = 609.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySnack3(this: INellieBlyStoryLayout_blySnack3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-snack.png", 0.500, 1.000);
	return this;
}
function NellieBlyStoryLayout_blyYSnackDrzoom(this: INellieBlyStoryLayout_blyYSnackDrzoom) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		NellieBlyStoryLayout_blySnackDrzoom1.call(items[0] as INellieBlyStoryLayout_blySnackDrzoom1);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 240.00;
		items[0].height = 157.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function NellieBlyStoryLayout_blySnackDrzoom1(this: INellieBlyStoryLayout_blySnackDrzoom1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bly-y-snack-drzoom.png", 0.500, 1.000);
	return this;
}
interface INellieBlyStoryLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface INellieBlyStoryLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface INellieBlyStoryLayoutSprite extends INellieBlyStoryLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface INellieBlyStoryLayoutText extends INellieBlyStoryLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface INellieBlyStoryLayoutPolygon extends Array<number> {
}
interface INellieBlyStoryLayout {
	readonly scene1Start: INellieBlyStoryLayout_scene1Start;
	readonly scene2Encounter: INellieBlyStoryLayout_scene2Encounter;
	readonly scene3Reaction: INellieBlyStoryLayout_scene3Reaction;
	readonly scene4Land: INellieBlyStoryLayout_scene4Land;
	readonly scene5Speech: INellieBlyStoryLayout_scene5Speech;
	readonly scene6End: INellieBlyStoryLayout_scene6End;
}
interface INellieBlyStoryLayout_scene1Start extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYSwing1|INellieBlyStoryLayout_blySeesaw2|INellieBlyStoryLayout_blyYDuck1|INellieBlyStoryLayout_blySlide1>;
}
interface INellieBlyStoryLayout_blyYSwing1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYSwing>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYSwing extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySeesaw2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySeesaw1|INellieBlyStoryLayout_blyYSeesaw1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySeesaw1 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyYSeesaw1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYSeesaw>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYSeesaw extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYDuck1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYDuck>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYDuck extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySlide1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySlideBack|INellieBlyStoryLayout_blyYSlide1|INellieBlyStoryLayout_blySlideFront>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySlideBack extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyYSlide1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYSlide>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYSlide extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySlideFront extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_scene2Encounter extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_slotStart|INellieBlyStoryLayout_paperLayer|INellieBlyStoryLayout_blyBird|INellieBlyStoryLayout_blyBalloon1|INellieBlyStoryLayout_blyWind|INellieBlyStoryLayout_blyKite1|INellieBlyStoryLayout_blyYReachout1>;
}
interface INellieBlyStoryLayout_slotStart extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySwing|INellieBlyStoryLayout_blySeesaw|INellieBlyStoryLayout_blyDuck|INellieBlyStoryLayout_blySlide>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySwing extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySwing1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySwing1 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blySeesaw extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySeesaw1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyDuck extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyDuck1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyDuck1 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blySlide extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySlideBack|INellieBlyStoryLayout_blySlideFront>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_paperLayer extends INellieBlyStoryLayoutContainer {
	isPaperLayer: boolean;
}
interface INellieBlyStoryLayout_blyBird extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBirdBack|INellieBlyStoryLayout_blyDrZoom|INellieBlyStoryLayout_blyBirdFront>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBirdBack extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyDrZoom extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyBirdFront extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyBalloon1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyDrZoom|INellieBlyStoryLayout_blyBalloon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBalloon extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyWind extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyDrZoom|INellieBlyStoryLayout_blyGust>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyGust extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyKite1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyDrZoom|INellieBlyStoryLayout_blyKite>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyKite extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyYReachout1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYReachout>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYReachout extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_scene3Reaction extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_slotStart|INellieBlyStoryLayout_blyBoat|INellieBlyStoryLayout_blyJetpack|INellieBlyStoryLayout_blyBike|INellieBlyStoryLayout_blyRollerskate1>;
}
interface INellieBlyStoryLayout_blyBoat extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBoatBack>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBoatBack extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyJetpack extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyJetpack1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyJetpack1 extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBike extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBicycle1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBicycle1 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyRollerskate1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyRollerskate>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyRollerskate extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_scene4Land extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlaygroundBg|INellieBlyStoryLayout_paperLayer|INellieBlyStoryLayout_slotLand|INellieBlyStoryLayout_blyDrZoom1|INellieBlyStoryLayout_slotRescueSpaghetti|INellieBlyStoryLayout_slotRescuePyramid|INellieBlyStoryLayout_slotRescuePlayground|INellieBlyStoryLayout_slotRescueMoon>;
}
interface INellieBlyStoryLayout_blyPlaygroundBg extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_slotLand extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySpaghetti1|INellieBlyStoryLayout_blyPyramid1|INellieBlyStoryLayout_blyPlayground|INellieBlyStoryLayout_blySpace>;
}
interface INellieBlyStoryLayout_blySpaghetti1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySpaghetti>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySpaghetti extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyPyramid1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPyramid>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyPyramid extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyPlayground extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlayground41|INellieBlyStoryLayout_blyPlayground3|INellieBlyStoryLayout_blyPlayground2|INellieBlyStoryLayout_blyPlayground1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyPlayground41 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlayground4>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyPlayground4 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyPlayground3 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlayground31>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyPlayground31 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyPlayground2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlayground21>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyPlayground21 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyPlayground1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlayground11>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyPlayground11 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blySpace extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySpace3|INellieBlyStoryLayout_blySpace2|INellieBlyStoryLayout_blySpace1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySpace3 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyMoon1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyMoon1 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blySpace2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyMoon3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyMoon3 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blySpace1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyMoon2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyMoon2 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyDrZoom1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyDrZoom11>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyDrZoom11 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_slotRescueSpaghetti extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBoat|INellieBlyStoryLayout_blyJetpack|INellieBlyStoryLayout_blyBike|INellieBlyStoryLayout_blyRollerskate1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_slotRescuePyramid extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBoat|INellieBlyStoryLayout_blyJetpack|INellieBlyStoryLayout_blyBike|INellieBlyStoryLayout_blyRollerskate1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_slotRescuePlayground extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBoat|INellieBlyStoryLayout_blyJetpack|INellieBlyStoryLayout_blyBike|INellieBlyStoryLayout_blyRollerskate1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_slotRescueMoon extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBoat1|INellieBlyStoryLayout_blyJetpack2|INellieBlyStoryLayout_blyBike1|INellieBlyStoryLayout_blyRollerskate2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBoat1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBoatBack>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyJetpack2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyJetpack1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBike1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBicycle3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBicycle3 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBicycle2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyBicycle2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyBicycle1>;
}
interface INellieBlyStoryLayout_blyRollerskate2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyRollerskate3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyRollerskate3 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyRollerskate>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_scene5Speech extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlaygroundBg|INellieBlyStoryLayout_paperLayer|INellieBlyStoryLayout_slotLand|INellieBlyStoryLayout_slotClimbSpaghetti|INellieBlyStoryLayout_slotClimbPyramid|INellieBlyStoryLayout_slotClimbPlayground|INellieBlyStoryLayout_slotClimbMoon|INellieBlyStoryLayout_slotHero|INellieBlyStoryLayout_blyYHero1|INellieBlyStoryLayout_blyDrZoom1>;
}
interface INellieBlyStoryLayout_slotClimbSpaghetti extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPizzastairsYadina1|INellieBlyStoryLayout_blyMonkeyBarSpaghetti|INellieBlyStoryLayout_blyLadderYadina1>;
}
interface INellieBlyStoryLayout_blyPizzastairsYadina1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPizzastairs>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyPizzastairs extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyMonkeyBarSpaghetti extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyMonkeyBars|INellieBlyStoryLayout_blyLandingPad>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyMonkeyBars extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyLandingPad extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyLadderYadina1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyLadder1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyLadder1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyLadder>;
}
interface INellieBlyStoryLayout_blyLadder extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_slotClimbPyramid extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPizzastairsYadina|INellieBlyStoryLayout_blyMonkeyBarsPyramid|INellieBlyStoryLayout_blyLadderYadina2>;
}
interface INellieBlyStoryLayout_blyPizzastairsYadina extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPizzastairs>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyMonkeyBarsPyramid extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyMonkeyBarsPyramid1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyMonkeyBarsPyramid1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyMonkeyBars|INellieBlyStoryLayout_blyLandingPad>;
}
interface INellieBlyStoryLayout_blyLadderYadina2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyLadder>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_slotClimbPlayground extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPizzastairsYadina|INellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina|INellieBlyStoryLayout_blyLadderYadina>;
}
interface INellieBlyStoryLayout_blyMonkeyBarPlaygroundYadina extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyMonkeyBars1|INellieBlyStoryLayout_blyLandingPad>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyMonkeyBars1 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyLadderYadina extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyLadder>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_slotClimbMoon extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPizzastairsYadina1|INellieBlyStoryLayout_blyMonkeyBarSpaghetti|INellieBlyStoryLayout_blyLadderYadina1>;
}
interface INellieBlyStoryLayout_slotHero extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYHero1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYHero1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYHero>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYHero extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_scene6End extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyPlaygroundBg|INellieBlyStoryLayout_paperLayer|INellieBlyStoryLayout_slotLand|INellieBlyStoryLayout_slotClimbSpaghetti|INellieBlyStoryLayout_slotClimbPyramid|INellieBlyStoryLayout_slotClimbPlayground|INellieBlyStoryLayout_slotClimbMoon|INellieBlyStoryLayout_slotEnd>;
}
interface INellieBlyStoryLayout_slotEnd extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYHug1|INellieBlyStoryLayout_blyYKiss1|INellieBlyStoryLayout_blyYSnack>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYHug1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYHug>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYHug extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYKiss1 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYKiss>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYKiss extends INellieBlyStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYSnack extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blyYSnack2|INellieBlyStoryLayout_blyYSnackDrzoom>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blyYSnack2 extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySnack3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySnack3 extends INellieBlyStoryLayoutSprite {
}
interface INellieBlyStoryLayout_blyYSnackDrzoom extends INellieBlyStoryLayoutContainer {
	readonly items: INellieBlyStoryLayoutArray<INellieBlyStoryLayout_blySnackDrzoom1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface INellieBlyStoryLayout_blySnackDrzoom1 extends INellieBlyStoryLayoutSprite {
}
